import app from 'app';
import ready from 'utils/ready';
import product from './product/main';
import recommendations from './product/recommendations';
import uspDrawer from './product/usp-drawer';
import suggestions from './product/suggestions';
import installationVideo from './product/installation-video';
import lightBox from './product/lightbox';

app.add({
  product,
  'product-recommendations': recommendations,
  'usp-drawer': uspDrawer,
  'product-suggestions': suggestions,
  'product-installation-video': installationVideo,
  'product-lightbox': lightBox,
});

ready(app.mount);
